import { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import { useDroneDetailContext } from '../Contexts/DroneDetailContext';
import { MenuItem, MeasureDistanceIcon, MeasureAreaIcon } from './MapActionMenu';

const MeasureMapMenu = ({GIS}) => {
  const { selectedTool, setSelectedTool } = useDroneDetailContext();

  const measureArea = () =>{
    setSelectedTool('area');
    GIS.Layer.removeFeatures('measure_area');
    GIS.Layer.removeFeatures('measure_line');
    GIS.Edit.drawFeatures('measure_area', 'Polygon', false, id => {setTimeout(() => {
      GIS.Edit.commit()
      setSelectedTool(null);}, 200)
    }, {style: 'measure_area'});
  }

  const measureDistance = () =>{
    setSelectedTool('distance');
    GIS.Layer.removeFeatures('measure_line');
    GIS.Layer.removeFeatures('measure_area');
    GIS.Edit.drawFeatures('measure_line', 'LineString', false, id => {setTimeout(() => {
      // GIS.Layer.getFeatureByID('measure_line', id, { attribute: 'id', format: 'geojson' }, geometry => {
      //   console.log(geometry);
      // });
      GIS.Edit.commit()
      setSelectedTool(null);}, 200)
    }, {style: 'measure_line'});
  }

  useEffect(() => {
    window.addEventListener('keydown', (key) => {
        if(key.key === 'Escape' && ['area', 'distance'].includes(selectedTool)) {
          setSelectedTool(null);
        }
    });
  }, [selectedTool]);

  return (
    <>
      <ReactTooltip type='light'/>
      <MenuItem data-tip="Measure Area" onClick={measureArea} active={selectedTool === 'area'}>
        <MeasureAreaIcon />
      </MenuItem>
      <MenuItem data-tip="Measure Distance"onClick={measureDistance} active={selectedTool === 'distance'}>
        <MeasureDistanceIcon />
      </MenuItem>
    </>
  );
}

export default MeasureMapMenu;